var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sale_types.length > 1)?_c('b-form-select',{attrs:{"options":_vm.getOptions({key: 'sale_type_id', text: 'Tipo venta'})},model:{value:(_vm.sale_type_id),callback:function ($$v) {_vm.sale_type_id=$$v},expression:"sale_type_id"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }